
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';


const reactPlugin = new ReactPlugin();


const browserHistory = createBrowserHistory();


const appInsights = new ApplicationInsights({
  config: {
    connectionString: 'InstrumentationKey=fbae0778-0007-4105-9df8-b154fffc30c8;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=1d6e3ec1-bd17-4c98-9d3a-1dd660958882', 
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    enableAutoRouteTracking: true, 
    enableCorsCorrelation: true, 
    enableRequestHeaderTracking: true, 
  }
});

appInsights.loadAppInsights(); 


export { appInsights, reactPlugin, browserHistory };
